export default {
  showLoading: function (state, payload) {
    state.isShowLoading = payload;
  },

  showSnackbar: function (state, { message, type }) {
    state.isShowSnackbar = true;
    state.snackbarMessage = message;
    state.snackbarType = type;

    setTimeout(() => {
      state.isShowSnackbar = false;
      state.snackbarType = null;
    }, 3500);
  },

  setQueryParams(state, payload) {
    if (Object.keys(payload).length > 0)
      state.queryParams = { ...state.queryParams, ...payload };
  },

  setState(state, payload) {
    if (typeof payload == "object") {
      Object.keys(payload).forEach((key) => {
        state[key] = payload[key];
      });
    } else console.warn("payload of setState must be an object!!");
  },
  setconfigInquiryRegister(state, configInquiryRegister) {
    state.configInquiryRegister = configInquiryRegister;
  },
};
